module.exports = __webpack_public_path__ + "img/17.6cd150c3.jpg";